// src/redux/services/store/storeSettingsApi.ts
import type { EndpointBuilder } from "@reduxjs/toolkit/query";
import { baseApi } from "../baseApi";

/** ---------------- Types (MATCH YOUR BACKEND) ---------------- */

export type StoreOut = {
  id: number;
  store_key: string;
  name: string;
  domain?: string | null;
  support_email?: string | null;
  support_phone?: string | null;
  country_code?: string | null;
  timezone: string;
};

export type StoreTaxRateOut = {
  id: number;
  store_id: number;
  name: string;
  rate: string; // Decimal string like "18.0000"
  is_inclusive: boolean;
  is_active: boolean;
  country_code?: string | null;
  state_code?: string | null;
  priority: number;
};

export type StoreAnalyticsOut = {
  enabled?: boolean | null;
  gtm_container_id?: string | null;
  ga_measurement_id?: string | null;
  meta_pixel_id?: string | null;
};

export type StorefrontPublicSettingsOut = {
  store: StoreOut;

  header_logo_url?: string | null;
  footer_logo_url?: string | null;
  favicon_url?: string | null;
  primary_color?: string | null;
  secondary_color?: string | null;

  default_currency_code?: string | null;
  default_currency_symbol?: string | null;

  price_includes_tax?: boolean | null;
  active_tax_rates: StoreTaxRateOut[];

  cod_enabled?: boolean | null;
  online_payment_enabled?: boolean | null;
  paypal_enabled?: boolean | null;
  analytics?: StoreAnalyticsOut | null;
};

/** ---------------- API ---------------- */

type Builder = EndpointBuilder<any, any, any>;

export const storeSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    // GET public storefront settings
    getStoreSettingsPublic: builder.query<StorefrontPublicSettingsOut, { store_key?: string } | void>({
      query: (args) => {
        const store_key = (args as any)?.store_key;
        return {
          url: `/store/settings/public`,
          method: "GET",
          params: store_key ? { store_key } : undefined,
        };
      },
      providesTags: () => [{ type: "StoreSettings", id: "PUBLIC" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetStoreSettingsPublicQuery } = storeSettingsApi;
